import { forwardRef } from 'react';
import { PlusIcon } from '@src/shared/ui/icons';
import IconButton, { type ExtendedIconButtonProps } from './IconButton';

type PlusIconButtonProps = ExtendedIconButtonProps & {
  iconColor?: 'primary' | 'inherit';
};

const PlusIconButton = forwardRef<HTMLButtonElement, PlusIconButtonProps>(
  (props, ref) => {
    const { iconColor = 'inherit', ...restProps } = props;

    return (
      <IconButton ref={ref} {...restProps}>
        <PlusIcon color={iconColor} />
      </IconButton>
    );
  },
);

PlusIconButton.displayName = 'PlusIconButton';
export default PlusIconButton;
